export var FolderableOperationValue;
(function (FolderableOperationValue) {
    FolderableOperationValue["OPEN"] = "open";
    FolderableOperationValue["SAVE_AS"] = "saveAs";
})(FolderableOperationValue || (FolderableOperationValue = {}));
